import React, { Component } from 'react';
import { SidebarPortal } from '@plone/volto/components';
import Sidebar from 'iovisit-museum-theme/components/Blocks/ListDownloadFile/Sidebar';
import Body from 'iovisit-museum-theme/components/Blocks/ListDownloadFile/Body';

class Edit extends Component {
  render() {
    if (__SERVER__) {
      return <div />;
    }

    return (
      <div className="block list-download-file">
        <Body {...this.props} isEditMode={true} />
        <SidebarPortal selected={this.props.selected}>
          <Sidebar {...this.props} />
        </SidebarPortal>
      </div>
    );
  }
}

export default Edit;
